import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { CityDto } from '@/modules/counterparty/dto/city.dto.ts';
import type { City } from '@/modules/counterparty/types/city.type.ts';

function normalizeCityName(value: unknown) {
  return String(value ?? '')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .trim();
}

export class CityAdapter {
  private static map(response: CityDto): City {
    return {
      name: normalizeCityName(response['Город']),
    };
  }

  static mapList(response: ItemsDto<CityDto>) {
    return response.items.map(CityAdapter.map).filter((city) => city.name.length > 0);
  }
}
